import Cookies from 'js-cookie';

export class HandleCookies {
  static setCookies({ name, value, config }) {
    return Cookies.set(name, value, config);
  }

  static getCookies({ name }) {
    return Cookies.get(name);
  }

  static removeCookies({ name }) {
    return Cookies.remove(name);
  }
}
